//////////// CSS /////////////
import './styles.css';

//////////// REACT /////////////
import React from "react";
import { Modal, Button } from 'react-bootstrap';

function PopupAlert(props) {

    return (
        <Modal show={props.state} onHide={props.onClose} dialogClassName="popup-alert-box-content">
            <Modal.Header className="popup-alert-header">
                <Modal.Title>{props.option.header}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="popup-alert-content">{props.option.content}</Modal.Body>
            <Modal.Footer className="popup-alert-box-bt">
                {
                    props.option.button.map((bt, bt_index) => (
                        <Button className="popup-alert-bt" style={bt.style} key={bt_index} onClick={bt.event}>{bt.name}</Button>
                    ))
                }
            </Modal.Footer>
        </Modal>
    )
}

export default PopupAlert;